const httpsUrlFromS3 = (originalUrl) => {
  const regex = /^s3:\/\/(.*?)\/(.*)$/;
  const matches = originalUrl.match(regex);
  try {
    if (matches) {
      const bucket = matches[1];
      const path = matches[2];
      // 构建替换后的 URL
      return `https://${bucket}.s3.us-west-2.amazonaws.com/${path}`;
    }
  } catch (e) {
    console.log("无法解析的 URL 格式");
  }
  return null;
};
export default httpsUrlFromS3;
